// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"a331e64d","716":"a366c74d"}[chunkId] + ".chunk.js";
};